import { stories } from "./stories";
export var defaultStage = {
    id: "default",
    title: "Missing, please reselect"
};
export function getStoryline(param) {
    var storylineId = param.storylineId;
    var storyline = stories.find(function(item) {
        return item.id === storylineId;
    });
    return storyline;
}
export var getStages = function(param) {
    var storylineId = param.storylineId;
    var storyline = getStoryline({
        storylineId: storylineId
    });
    return (storyline === null || storyline === void 0 ? void 0 : storyline.stages) || [];
};
export function getStage(param) {
    var storylineId = param.storylineId, stageId = param.stageId;
    var _storyline_stages;
    var storyline = getStoryline({
        storylineId: storylineId
    });
    var stage = storyline === null || storyline === void 0 ? void 0 : (_storyline_stages = storyline.stages) === null || _storyline_stages === void 0 ? void 0 : _storyline_stages.find(function(item) {
        return item.id === stageId;
    });
    return stage || defaultStage;
}
export function getStagesRemainingCount(param) {
    var storylineId = param.storylineId, stageId = param.stageId;
    var _storyline_stages, _storyline_stages1;
    var storyline = getStoryline({
        storylineId: storylineId
    });
    var stageIndex = storyline === null || storyline === void 0 ? void 0 : (_storyline_stages = storyline.stages) === null || _storyline_stages === void 0 ? void 0 : _storyline_stages.findIndex(function(item) {
        return item.id === stageId;
    });
    return (storyline === null || storyline === void 0 ? void 0 : (_storyline_stages1 = storyline.stages) === null || _storyline_stages1 === void 0 ? void 0 : _storyline_stages1.length) - stageIndex - 1 || 0;
}
export function getStorylineTitle(param) {
    var storylineId = param.storylineId;
    var storyline = getStoryline({
        storylineId: storylineId
    });
    return (storyline === null || storyline === void 0 ? void 0 : storyline.title) || "title not found";
}
export function getStageTitle(param) {
    var storylineId = param.storylineId, stageId = param.stageId;
    var stage = getStage({
        storylineId: storylineId,
        stageId: stageId
    });
    return (stage === null || stage === void 0 ? void 0 : stage.title) || "stage title not found";
}
export var getStorylineOptions = function() {
    var storylines = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : stories;
    return storylines.map(function(param) {
        var id = param.id, title = param.title;
        return {
            id: id,
            value: id,
            active: title,
            inactive: "".concat(title, "?")
        };
    });
};
